"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const load_1 = __importDefault(require("./load"));
const autocompleteMetadata = {
    load: load_1.default,
};
exports.default = autocompleteMetadata;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbWV0YWRhdGEvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMEI7QUFFMUIsTUFBTSxvQkFBb0IsR0FBRztJQUMzQixJQUFJLEVBQUosY0FBSTtDQUNMLENBQUM7QUFFRixrQkFBZSxvQkFBb0IsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBsb2FkIGZyb20gJy4vbG9hZCc7XG5cbmNvbnN0IGF1dG9jb21wbGV0ZU1ldGFkYXRhID0ge1xuICBsb2FkLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgYXV0b2NvbXBsZXRlTWV0YWRhdGE7XG4iXX0=